<div
  class="banner"
  [ngStyle]="urlBanner">
  <ng-content></ng-content>
</div>
